export default __webpack_public_path__ + "static/media/My.t.7448046c.png";